import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";
import Button from "../shared/Button";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";

interface Props {
  title?: string;
  text: string;
  handleConfirm: () => void;
  handleCancel: () => void;
}

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
}));

export default function Confirmation({
  title,
  text,
  handleConfirm,
  handleCancel,
}: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={true} onClose={handleCancel}>
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={classes.text}
        >
          {text}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleConfirm}>{t("confirmation.confirm")}</Button>
        <Button onClick={handleCancel}>{t("confirmation.cancel")}</Button>
      </DialogActions>
    </Dialog>
  );
}
